import { isRecord } from "./util";
const uniq = "revotale_nextjs_scroll_restoration";
const getKey = (pos) => `${uniq}_${pos}`;
const defaultX = 0;
const defaultY = 0;
const setCurrentScrollHistory = ([x, y]) => {
  x = Math.max(x, defaultX);
  y = Math.max(y, defaultY);
  const winState = window.history.state;
  const newState = (isRecord(winState) ? winState : null) ?? {};
  window.history.replaceState({
    ...newState,
    [getKey("x")]: x,
    [getKey("y")]: y,
    [getKey("memo_timestamp")]: (/* @__PURE__ */ new Date()).getTime()
  }, "");
};
const retrieveNum = (name, state) => {
  if (state === null) {
    return null;
  }
  const key = getKey(name);
  const { [key]: value } = state;
  if (value === null) {
    return null;
  }
  const num = Number(value);
  return isNaN(num) ? null : num;
};
const getScrollFromState = (state) => {
  const x = retrieveNum("x", state);
  const y = retrieveNum("y", state);
  return x !== null && y !== null ? [x, y] : null;
};
const getScrollTimestamp = (state) => retrieveNum("memo_timestamp", state);
const getPopstateTimestamp = (state) => retrieveNum("popstate_timestamp", state);
const getIsNavigatingHistory = (state) => state !== null ? Boolean(state[getKey("is_navigating_history")]) : false;
export {
  getIsNavigatingHistory,
  getKey,
  getPopstateTimestamp,
  getScrollFromState,
  getScrollTimestamp,
  setCurrentScrollHistory
};
//# sourceMappingURL=storage.js.map